<style scoped>
    .container{
        position: relative;
        text-align: center;
    }
    .team{
        position: relative;
        display: inline-block;
        vertical-align: top;
        width: 240px;
        height: 160px;
        border: 1px solid #dddee1;
        margin: 6px;
        background-color: white;
        transition: .4s;
    }
    .team:hover{
        cursor: pointer;
        transform: translate3d(0, -5px, 0);
        box-shadow: 0 5px 8px rgba(110,110,110,.2);
    }
    .team-avatar{
        width: 100%;
        height: 100%;
    }
    .team-name{
        display: block;
        width: 100%;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 20px;
    }
    .page-info{
        text-align: left;
    }
    .formal-drawer /deep/ .ivu-modal-content{
        background: transparent;
    }
    .formal-drawer /deep/ .ivu-modal-body{
        padding-top: 40px;
        padding-bottom: 44px;
        max-height: inherit;
        text-align: center;
    }
    .formal-drawer /deep/ .ivu-modal-footer{
        background: white;
    }
    .formal-drawer /deep/ .ivu-icon-ios-close{
        font-size: 40px;
        color: white;
        transition: .4s;
    }
    .formal-drawer /deep/ .ivu-icon-ios-close:hover{
        color: white;
        transform: scale(1.1, 1.1);
    }
</style>
<template>
  <div class="container">
    <div
      v-for="team in teams"
      :key="team.id"
      class="team"
      @click="showTeamDetail(team)"
    >
      <img
        v-if="team.avatar"
        class="team-avatar"
        :src="pubOssUrl(team.avatar)"
      >
      <span
        v-else
        class="team-name"
      >{{ team.name }}</span>
    </div>
    <Spin
      v-if="getting_teams"
      fix
    />

    <Modal
      v-model="config.modal"
      class="formal-drawer"
      fullscreen
    >
      <IntroCard
        v-for="customer in customers"
        :key="customer.id"
        :customer="customer"
      />
      <Spin
        v-show="loading"
        fix
      />
      <div
        slot="footer"
        class="page-info"
      >
        <Page
          v-show="page_info.total"
          show-total
          show-elevator
          :current="page_info.current"
          :total="page_info.total"
          :page-size="page_info.page_size"
          @on-change="pageChange"
        />
      </div>
    </Modal>
  </div>
</template>
<script route="/common/schoolmate">
  import IntroCard from '../components/customer/intro_card';
  export default {
    /* router_info_start */
    router_info: '/common/schoolmate',
    /* router_info_end */
    components: { IntroCard },
    data() {
      return {
        params: {
          page: 1,
          team_id : 0
        },
        page_info: {
          current: 1,
          total: 0,
          page_size: 10
        },
        getting_teams: false,
        loading: false,
        config: {
          modal: false
        },
        teams: [],
        customers: [],
        cur_team: {}
      }
    },
    computed: {
      //
    },
    created() {
      this.getSortedTeams();
    },
    mounted() {
      //
    },
    methods: {
      getSortedTeams() {
        this.getting_teams = true;
        Util.ajax.get(Util.api.parent_teams).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.teams = res.data.teams;
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.getting_teams = false;
        });
      },
      showTeamDetail(team) {
        this.cur_team = team;
        this.params.team_id = team.id;
        this.resetPageInfo();
        this.getTeamCustomers();
        this.config.modal = true;
      },
      resetPageInfo() {
        this.params.page = 1;
        this.page_info.current = 1;
        this.page_info.total = 0;
      },
      pageChange(page) {
        this.params.page = page;
        this.getTeamCustomers();
      },
      getTeamCustomers() {
        if (!this.params.team_id) return;
        this.loading = true;
        this.customers = [];
        Util.ajax.get(Util.api.team_formal_customers, {
          params: this.params
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            this.handleCustomers(data.customers);
            this.page_info.current = data.cur_page;
            this.page_info.page_size = data.per_page;
            this.page_info.total = data.total_count;
            this.getCustomerBadges();
          } else {
            this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          this.$Modal.warning({title: '错误', content: e.message});
        }).finally(() => {
          this.loading = false;
        });
      },
      handleCustomers(customers) {
        this.customers_hash = {};
        customers.forEach((c) => {
          c.badges = [];
          this.customers_hash[c.id] = c;
        });
        this.customers = customers;
      },
      getCustomerBadges() {
        if (!this.customers.length) return;
        Util.ajax.get(Util.api.customer_activity_badges, {
          params: {
            ids: this.customers.map((c) => {return c.id})
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            const data = res.data;
            data.badges.forEach((badge) => {
              const customer = this.customers_hash[badge.staffId];
              if (customer) {
                customer.badges = badge.badges;
              }
            });
          } else {
            //this.$Modal.warning({title: '错误', content: res.msg});
          }
        }).catch((e) => {
          //this.$Modal.warning({title: '错误', content: e.message});
        });
      },
      avatarUrl(avatar) {
        return Util.avatarUrl(avatar);
      },
      pubOssUrl(filepath) {
        return filepath;
      }
    }
  }
</script>
